// Contenuti statici del sito, facilmente modificabili.

export const CATEGORY_LABELS = {
  telefoni: "Telefoni",
  cuffie: "Cuffie",
  auricolari: "Auricolari",
  smartwatch: "Smartwatch",
  fotocamere: "Fotocamere",
  casa: "Casa",
};

export const GRADE_INFO = {
  nuovo: {
    label: "Nuovo",
    short: "Nuovo, sigillato",
    title: "Nuovo",
    description: "Prodotto nuovo e sigillato, mai utilizzato.",
    bullets: ["Confezione originale sigillata", "Garanzia 12 mesi inclusa", "Spedizione tracciata"],
    price_hint: "Listino ufficiale",
    wear: 3,
  },
  like_new: {
    label: "Come nuovo",
    short: "Come nuovo",
    title: "Come nuovo",
    description: "Nessun segno visibile.",
    bullets: [
      "Nessun segno visibile su scocca e display",
      "Batteria con capacità garantita superiore all'85%",
      "Accessori compatibili inclusi",
    ],
    price_hint: "Il più vicino al nuovo",
    wear: 2,
  },
  used: {
    label: "Usato",
    short: "Usato",
    title: "Usato",
    description: "Lievi segni d'uso. Funzionalità identica.",
    bullets: [
      "Microsegni visibili solo in controluce",
      "Display integro, nessun graffio profondo",
      "Stessi test e stessa garanzia della versione Come nuovo",
    ],
    price_hint: "Il miglior rapporto qualità/prezzo",
    wear: 1,
  },
};

// Badge fiducia monospace — integrati nel design, mai banner.
export const TRUST_BADGES = [
  { key: "shipping", icon: "truck", label: "Spedizione tracciata" },
  { key: "warranty", icon: "shield-check", label: "Garanzia 12 mesi" },
  { key: "returns", icon: "rotate-ccw", label: "Reso 14 giorni" },
  { key: "tested", icon: "list-checks", label: "Testato su 32 punti di controllo" },
];

// Compat con la versione precedente
export const TRUST_POINTS = [
  { icon: "truck", title: "Spedizione tracciata", text: "Su ogni ordine, sempre monitorabile." },
  { icon: "shield-check", title: "Garanzia 12 mesi", text: "Inclusa su tutti i prodotti." },
  { icon: "rotate-ccw", title: "Resi entro 14 giorni", text: "Cambia idea in tutta serenità." },
  { icon: "lock", title: "Pagamenti sicuri", text: "Transazioni protette e affidabili." },
];

// Numeri chiave (placeholder editabili) — count-up in home.
export const STATS = [
  { key: "devices", value: 12400, suffix: "+", label: "Dispositivi ricondizionati" },
  { key: "customers", value: 9800, suffix: "+", label: "Clienti in Italia" },
  { key: "warranty", value: 12, suffix: "", label: "Mesi di garanzia" },
  { key: "checks", value: 32, suffix: "", label: "Punti di controllo" },
];

// "Cosa abbiamo verificato": 8 gruppi = 32 test.
export const CHECKLIST_GROUPS = [
  { label: "Accensione e alimentazione", tests: 3 },
  { label: "Display e superfici", tests: 5 },
  { label: "Batteria e autonomia", tests: 4 },
  { label: "Audio e microfoni", tests: 4 },
  { label: "Connettività (Wi-Fi, Bluetooth, porte)", tests: 6 },
  { label: "Sensori e pulsanti", tests: 4 },
  { label: "Struttura e componenti", tests: 3 },
  { label: "Software e ripristino", tests: 3 },
];

export const NAV_LINKS = [
  { label: "Catalogo", to: "/catalogo" },
  { label: "Offerte", to: "/offerte" },
  { label: "Valuta il tuo dispositivo", to: "/valuta" },
];

export const FOOTER_COLUMNS = [
  {
    title: "Acquista",
    links: [
      { label: "Catalogo completo", to: "/catalogo" },
      { label: "Tutti i marchi", to: "/catalogo" },
      { label: "Telefoni", to: "/catalogo?category=telefoni" },
      { label: "Cuffie e auricolari", to: "/catalogo?category=cuffie" },
    ],
  },
  {
    title: "Assistenza",
    links: [
      { label: "Spedizioni e resi", to: "/spedizioni-e-resi" },
      { label: "Garanzia", to: "/garanzia" },
      { label: "FAQ", to: "/faq" },
      { label: "Contatti", to: "/contatti" },
    ],
  },
  {
    title: "Azienda",
    links: [
      { label: "Chi siamo", to: "/chi-siamo" },
      { label: "Valuta il tuo dispositivo", to: "/valuta" },
    ],
  },
];

export const HOME = {
  hero: {
    eyebrow: "Nuovo e ricondizionato · Garantito 12 mesi",
    title: "Tecnologia di qualità, a un prezzo che tutti possono permettersi.",
    subtitle:
      "Telefoni e accessori tech verificati in ogni componente. Nuovi o ricondizionati in due condizioni — Come nuovo e Usato — con la stessa garanzia di 12 mesi e totale trasparenza.",
  },
  howItWorks: {
    eyebrow: "Il metodo RINOVA",
    title: "Come funziona il ricondizionato",
    subtitle:
      "Ogni prodotto ricondizionato è testato e classificato. Cambia solo l'estetica: la funzionalità è sempre verificata.",
  },
  featured: {
    eyebrow: "In vetrina",
    title: "In evidenza",
  },
  stats: {
    eyebrow: "In numeri",
    title: "Ricondizionato come si deve. Verificato, garantito, tracciato.",
  },
  tradein: {
    eyebrow: "Valuta il tuo dispositivo",
    title: "Hai un dispositivo da vendere?",
    subtitle:
      "Ricevi una valutazione entro 24-48h, spedisci gratuitamente e vieni pagato dopo la verifica. Semplice e trasparente.",
    steps: [
      { n: "01", label: "Valutazione in 24–48h" },
      { n: "02", label: "Spedizione gratuita" },
      { n: "03", label: "Pagamento dopo verifica" },
    ],
  },
};

export const SERVICE_PAGES = {
  "chi-siamo": {
    title: "Chi siamo",
    subtitle: "Tecnologia verificata e garantita, accessibile a tutti.",
    sections: [
      {
        heading: "La nostra missione",
        body: "RINOVA nasce per rendere la buona tecnologia accessibile senza compromessi. Selezioniamo telefoni e accessori nuovi e ricondizionati, li verifichiamo in ogni componente e li offriamo a un prezzo onesto, con piena trasparenza sulle condizioni.",
      },
      {
        heading: "Come lavoriamo",
        body: "Ogni prodotto ricondizionato passa attraverso test funzionali completi e una classificazione estetica in due sole condizioni: Come nuovo e Usato. Ti diciamo sempre con chiarezza cosa stai acquistando, così puoi scegliere in base al tuo budget senza sorprese.",
      },
      {
        heading: "Il nostro impegno",
        body: "Garanzia di 12 mesi su tutto, resi entro 14 giorni e spedizione tracciata su ogni ordine. Scegliere ricondizionato significa anche ridurre gli sprechi: buono per te e per l'ambiente.",
      },
    ],
  },
  "spedizioni-e-resi": {
    title: "Spedizioni e resi",
    subtitle: "Tutto quello che c'è da sapere su consegna e reso.",
    sections: [
      {
        heading: "Spedizione",
        body: "Spediamo con corriere tracciato su ogni ordine. La consegna avviene in genere entro 2-4 giorni lavorativi dalla conferma. Ricevi il codice di tracciamento via email non appena il pacco parte.",
      },
      {
        heading: "Resi entro 14 giorni",
        body: "Hai 14 giorni dalla consegna per ripensarci. Il prodotto va restituito integro e nella confezione originale. Una volta ricevuto e verificato, procediamo con il rimborso.",
      },
      {
        heading: "Come richiedere un reso",
        body: "Scrivici indicando il numero d'ordine e il motivo del reso. Ti guidiamo passo passo nella procedura di spedizione di ritorno.",
      },
    ],
  },
  garanzia: {
    title: "Garanzia",
    subtitle: "12 mesi di garanzia su ogni prodotto, nuovo o ricondizionato.",
    sections: [
      {
        heading: "Cosa copre la garanzia",
        body: "Tutti i prodotti sono coperti da 12 mesi di garanzia su difetti di funzionamento. La garanzia non copre i danni accidentali o l'usura estetica dichiarata al momento dell'acquisto (condizione del prodotto).",
      },
      {
        heading: "Come funziona",
        body: "In caso di malfunzionamento entro il periodo di garanzia, contattaci con il numero d'ordine. Valuteremo il problema e provvederemo alla riparazione o alla sostituzione.",
      },
    ],
  },
  faq: {
    title: "Domande frequenti",
    subtitle: "Le risposte alle domande più comuni.",
    faq: [
      {
        q: "Cosa significa prodotto ricondizionato?",
        a: "Un prodotto ricondizionato è stato usato, poi verificato, testato e rimesso a nuovo nel funzionamento. Lo classifichiamo in due condizioni — Come nuovo e Usato — in base all'estetica: la funzionalità è sempre perfetta.",
      },
      {
        q: "Che differenza c'è tra Come nuovo e Usato?",
        a: "Come nuovo: nessun segno visibile. Usato: lievi segni d'uso, visibili solo in controluce, con funzionalità identica. Cambia solo l'aspetto e il prezzo.",
      },
      {
        q: "I prodotti sono garantiti?",
        a: "Sì, ogni prodotto è coperto da 12 mesi di garanzia, sia nuovo che ricondizionato.",
      },
      {
        q: "Posso restituire un prodotto?",
        a: "Certo, hai 14 giorni dalla consegna per il reso, purché il prodotto sia integro e nella confezione originale.",
      },
      {
        q: "Come funziona la valutazione del mio dispositivo?",
        a: "Compili il form 'Valuta il tuo dispositivo', ricevi una valutazione entro 24-48h, spedisci gratuitamente e vieni pagato dopo la verifica.",
      },
    ],
  },
  contatti: {
    title: "Contatti",
    subtitle: "Siamo qui per aiutarti.",
    sections: [
      {
        heading: "Assistenza clienti",
        body: "Scrivici a supporto@rinova.it. Rispondiamo entro un giorno lavorativo, dal lunedì al venerdì.",
      },
      {
        heading: "Ordini e resi",
        body: "Per domande su un ordine, indica sempre il numero d'ordine (formato RN-...) per un'assistenza più rapida.",
      },
    ],
  },
};
